/**
 * @generated SignedSource<<0dd947f60cc17623d45140c2b4a30509>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
import { FragmentRefs } from "relay-runtime";
export type ConnectAdminCreateInit_item$data = {
  readonly icon: TodoCategoryIcon | null;
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "ConnectAdminCreateInit_item";
};
export type ConnectAdminCreateInit_item$key = {
  readonly " $data"?: ConnectAdminCreateInit_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectAdminCreateInit_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectAdminCreateInit_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    }
  ],
  "type": "TodoCategory",
  "abstractKey": null
};

(node as any).hash = "287b1122e847cf78a04d03a17dbc1ac7";

export default node;
